module.exports = __webpack_public_path__ + "img/39fb849.png";